module.exports = __webpack_public_path__ + "static/media/postman.c108f557.png";